import React from 'react';
import './App.css';
import PasswordGenerator from './PasswordGenerator.tsx';

function App() {
  return (
    <div className="App">
      <PasswordGenerator />
    </div>
  );
}

export default App;
